var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5465 1.8335C10.8335 1.8335 9.41269 3.00798 9.00592 4.59495C8.96009 4.59495 8.92572 4.5835 8.87988 4.5835C6.85749 4.5835 5.21322 6.22777 5.21322 8.25016C5.21322 8.52516 5.24759 8.79443 5.31061 9.05225C3.6377 9.73975 2.46322 11.3783 2.46322 13.2918C2.46322 14.0137 2.64655 14.684 2.93874 15.2913C1.56374 16.0819 0.629883 17.5486 0.629883 19.2502C0.629883 21.158 1.79863 22.7965 3.46009 23.484C3.40853 23.7476 3.37988 24.0168 3.37988 24.2918C3.37988 26.572 5.22467 28.4168 7.50488 28.4168C7.73978 28.4168 7.96895 28.3882 8.19238 28.3481C8.74238 29.9809 10.2663 31.1668 12.0882 31.1668C14.3684 31.1668 16.2132 29.322 16.2132 27.0418V5.50016C16.2132 3.47777 14.5689 1.8335 12.5465 1.8335ZM33.6299 19.2502C33.6299 17.5486 32.696 16.0819 31.321 15.2913C31.6189 14.684 31.7966 14.0137 31.7966 13.2918C31.7966 11.3783 30.6221 9.73975 28.9492 9.05225C29.0064 8.79443 29.0466 8.52516 29.0466 8.25016C29.0466 6.22777 27.4023 4.5835 25.3799 4.5835C25.334 4.5835 25.2939 4.59495 25.2538 4.59495C24.8471 3.00798 23.4262 1.8335 21.7132 1.8335C19.6908 1.8335 18.0466 3.47204 18.0466 5.50016V27.0418C18.0466 29.322 19.8913 31.1668 22.1716 31.1668C23.9934 31.1668 25.5174 29.9809 26.0674 28.3481C26.2908 28.3882 26.52 28.4168 26.7549 28.4168C29.0351 28.4168 30.8799 26.572 30.8799 24.2918C30.8799 24.0168 30.8512 23.7476 30.7997 23.484C32.4611 22.7965 33.6299 21.158 33.6299 19.2502Z",
    fill: "#5F7F04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.629883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/SVG.f452bdd6f75d0d8b298ee8b1efaf8ec4.svg";
export { ForwardRef as ReactComponent };